var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"sensor-img",attrs:{"src":_vm.sensorImage}}),_vm._v(" "+_vm._s(_vm.sensor.serial)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }